import { useState, useEffect } from "react";
// import { getUserSession } from "@/actions/user/auth";
import { fetchUserDetails } from "@/actions/fetchQueryData";
import { logOut as serverLogOut } from "@/actions/user/auth";
import { getUserSession } from "@/actions/admin/admin";

export const useSession = () => {
  const [session, setSession] = useState<{
    isAuthenticated: boolean;
    user: any;
  }>({
    isAuthenticated: false,
    user: null,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const sessionData = await getUserSession();
        const userData = sessionData ? await fetchUserDetails() : null;

        setSession({
          isAuthenticated: !!sessionData,
          user: userData,
        });
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchSession();
  }, []);

  const logOut = async () => {
    try {
      await serverLogOut();

      setSession({
        isAuthenticated: false,
        user: null,
      });
    } catch (err) {
      setError(err as Error);
    }
  };

  return { session, loading, error, logOut };
};